'use client';

import type { InputHTMLAttributes, ReactNode } from 'react';

/** Switch (role=switch, state JS-driven via aria-checked). */
export function Toggle({
  checked,
  onChange,
  disabled,
  label,
}: {
  checked: boolean;
  onChange?: (next: boolean) => void;
  disabled?: boolean;
  label?: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      className="mx-toggle"
      onClick={() => onChange?.(!checked)}
    >
      <span className="mx-toggle__thumb" />
    </button>
  );
}

export function Checkbox({ label, className, ...props }: InputHTMLAttributes<HTMLInputElement> & { label?: ReactNode }) {
  return (
    <label className={`mx-check${className ? ` ${className}` : ''}`}>
      <input type="checkbox" {...props} />
      <span className="mx-check__box" aria-hidden="true">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 6 9 17l-5-5" />
        </svg>
      </span>
      {label != null && <span>{label}</span>}
    </label>
  );
}

export function Radio({ label, className, ...props }: InputHTMLAttributes<HTMLInputElement> & { label?: ReactNode }) {
  return (
    <label className={`mx-radio${className ? ` ${className}` : ''}`}>
      <input type="radio" {...props} />
      <span className="mx-radio__dot" aria-hidden="true" />
      {label != null && <span>{label}</span>}
    </label>
  );
}
